import dayjs from "dayjs";

const calculateAgeDay = (birthday: Date, currentDate: dayjs.Dayjs) => {
    // Calculate the age in years
    const age = currentDate.diff(birthday, "year");

    // Calculate the remaining days until the next birthday
    const priorBirthday = new Date(birthday.getTime());
    priorBirthday.setFullYear(birthday.getFullYear() + age);

    const ageMonth = currentDate.diff(priorBirthday, "month");

    priorBirthday.setMonth(priorBirthday.getMonth() + ageMonth);

    const ageDay = currentDate.diff(priorBirthday, "day");

    return { age, ageMonth, ageDay };
};

export default calculateAgeDay;
